import CryptoJS from 'crypto-js'

class HigiaCryptoService {
    KEY = 'higia'

    public encrypted(value: any, isObj: boolean) {
        value = isObj ? JSON.stringify(value) : value
        return CryptoJS.AES.encrypt(value, this.KEY).toString()
    }

    public decrypt(encrypted: any) {
        return CryptoJS.AES.decrypt(encrypted, this.KEY).toString(CryptoJS.enc.Utf8)
    }
}

export { HigiaCryptoService }
export default HigiaCryptoService
